import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import App from "./App";
import { postLogin } from "./apiService";
import { jwtDecode } from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../src/components/pages/Logo/favicon.png";
import "./Login.css";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();

  const branchId = 1;
  const companyId = 1;

  const handleLogin = async () => {
    try {
      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const isSuper =
        String(responseData.isSuperAdmin).toLowerCase() === "true";

      if (!isSuper) {
        const parsedCompanyId = parseInt(responseData.companyId, 10);
        if (parsedCompanyId !== companyId) {
          toast.error("Invalid User !", { position: "top-center" });
          return;
        }
      }
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );


      login(
        responseData.companyId,
        responseData.branchId,
        responseData.userId,
        isSuper,
        responseData.superAdminCompanyId,
        responseData.CompanyName,
        permissions,
        jwtToken,
        responseData.roleName,
        responseData.branchstate,
        responseData.username
      );

      const redirectParam = new URLSearchParams(location.search).get("redirect");
      const redirectPath = redirectParam
        ? decodeURIComponent(redirectParam)
        : "/Home";
      history.replace(redirectPath);
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed", { position: "top-center" });
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId
    };

    const response = await postLogin("LoginApi", loginData);

    if (response.responseCode === "1111") {
      return response.response_data.token;
    } else {
      throw new Error(response.Message);
    }
  };

  if (isAuthenticated) {
    return <App />;
  }

  return (
    <div className="login-container">
      {/* 🔹 Animated Wavy Background */}
      <div className="wave-bg">
        <div className="wave wave1"></div>
        <div className="wave wave2"></div>
        <div className="wave wave3"></div>
      </div>

      {/* 🔹 Login Card */}
      <section className="login-card">
        <div className="logo-block">
          <img src={Logo} alt="Logo" className="logo-img" />
          <h5 className="logo-title">Rashid Al Hadi Trading</h5>
        </div>

        <p className="subtitle">Login To Your Account</p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          {/* Username field */}
          <div className="input-block">
            <FaUser className="input-icon" />
            <input
              type="text"
              placeholder="User Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-field"
            />
          </div>

          {/* Password field */}
          <div className="input-block">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
            <div
              onClick={() => setShowPassword((prev) => !prev)}
              className="eye-icon"
            >
              {showPassword ? (
                <FaEyeSlash style={{ color: "#e63946" }} />
              ) : (
                <FaEye style={{ color: "#7ADAA5" }} />
              )}
            </div>
          </div>

          {/* Login button */}
          <button type="submit" className="login-btn">
            Login
          </button>
        </form>
      </section>
    </div>
  );
};

export default LoginForm;
